import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getResultMeetingSlice = createSlice({
    name: 'ResultMeeting',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchResultMeeting.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchResultMeeting.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchResultMeeting.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setResultMeeting, setStatus } = getResultMeetingSlice.actions;
export default getResultMeetingSlice.reducer;

export const fetchResultMeeting = createAsyncThunk('/ResultMeeting/fetch', async ({ Value6, data1,data2,data3,data4,data5,data6,data7,data8,data9,data10,data11,data12,data13,data14, IncreasePage4 }) => {
    const res = await axios.get(`${getBaseUrl()}/ResultMeeting?NameEn=${Value6}&size=${IncreasePage4}&StartTimeOfRace=${data1}&HorseID=${data2}&TrainerOnRace=${data3}&JockeyOnRace=${data4}&RaceCourseOfRace=${data5}&RaceCourseNationality=${data6}&RaceTypeOfRace=${data7}&RaceGround=${data8}&RaceTracklength=${data9}&OwnerId=${data10}&MeetingType=${data11}&Sponsor=${data12}&HorseKindinRace=${data13}&date=${data14}`);
    const ResultMeetingData = res.data;
    return ResultMeetingData.data;
})
